var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "ring-icon-remove",
  "use": "ring-icon-remove-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"ring-icon-remove\"><path d=\"M8 1.4a6.598 6.598 0 1 1-6.6 6.597A6.606 6.606 0 0 1 8 1.4M8 0a7.997 7.997 0 1 0 8 7.997A7.999 7.999 0 0 0 8 0z\" /><path d=\"M11.866 5.196l-1.06-1.06-2.803 2.803L5.2 4.136l-1.06 1.06L6.942 8 4.14 10.803l1.06 1.06L8.003 9.06l2.803 2.803 1.06-1.06L9.063 8l2.803-2.804z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id